<template>
  <div ref="layout" class="page-container">
    <div class="query-title">KA卖场维护</div>
    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form inline class="form" size="mini" label-width="100px">
              <el-row>
                <el-col :span="8">
                  <el-form-item class="widget-view" label="KA卖场简称">
                    <el-input v-model="conditions.shortName" placeholder="请输入" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item class="widget-view" label="卖场区域">
                    <el-select v-model="conditions.area" clearable>
                      <el-option
                        v-for="item in provinceList"
                        :key="item.id"
                        :label="item.cityName"
                        :value="item.cityNo"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="queryData(1)">查询</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <TableCommon
          title="明细"
          :custome-config="() => vxeShowCustom('gridOptions')"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
        >
          <template #button>
            <table-button name="add" tip="新增" @click="openDialog" />
            <table-button name="delete" tip="删除" @click="delKa" />
          </template>
          <vxe-grid
            ref="gridOptions"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            max-height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            @cell-dblclick="editRow"
          />
        </TableCommon>
      </div>

    </div>

    <el-dialog v-dialogDrag :visible.sync="addDialog" title="新增KA卖场">
      <el-form
        ref="addForms"
        class="form-query"
        :rules="rules"
        size="mini"
        label-width="80px"
        label-position="left"
        inline
        :model="addForm"
      >
        <el-row class="addForm">
          <el-col :span="12">
            <el-form-item label="卖场简称" prop="shortName">
              <el-input v-model="addForm.shortName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖场全称" prop="fullName">
              <el-input v-model="addForm.fullName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="区域" prop="area">
              <el-select v-model="addForm.area" clearable>
                <el-option
                  v-for="item in provinceList"
                  :key="item.id"
                  :label="item.cityName"
                  :value="item.cityNo"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属品牌" prop="brand">
              <el-input v-model="addForm.brand" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="区域类型" prop="areaType">
              <el-input v-model="addForm.areaType" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="comment">
              <el-input v-model="addForm.comment" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="closeDialog"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitAdd"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiCityArea } from '@/api/common'
import { apiKastoreAddKA, apiKastoreList, apiKastoreDelete } from '@/api/applyForGoods/goods-ka'
export default {
  name: 'ka-stores',
  data() {
    const rules = {
      fullName: [{ required: true, message: '请输入全称', trigger: 'blur' }],
      shortName: [{ required: true, message: '请输入简称', trigger: 'blur' }]
    }
    return {
      rules,
      addForm: {
        area: '',
        areaName: '',
        areaType: '',
        brand: '',
        comment: '',
        fullName: '',
        shortName: ''
      },
      addDialog: false,
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      conditions: {
        shortName: '',
        area: ''
      },
      provinceList: [],
      selectDataOptions: {},
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 50 },
          { field: 'shortName', title: 'KA卖场简称' },
          { field: 'fullName', title: 'KA卖场全称' },
          { field: 'brand', title: '所属品牌' },
          { field: 'areaName', title: '所属区域' },
          { field: 'areaType', title: '卖场区域类型' },
          { field: 'createDate', title: '创建时间' },
          { field: 'comment', title: '备注' }
        ],
        data: []
      }
    }
  },
  created() {
    this.getCityArea()
  },
  methods: {
    filterArea(code) {
      return this.provinceList.find(v => v.cityNo === code)?.cityName || ''
    },
    async queryData(page) {
      page && (this.pagination.page = page)
      const params = {
        ...this.conditions,
        ...this.pagination
      }
      const {
        data: { Rows, Total }
      } = await apiKastoreList(params)

      this.gridOptions.data = Rows
      this.pagination.totalCount = Total
    },
    closeDialog() {
      this.$refs.addForms.resetFields()
      this.addDialog = false
    },
    openDialog() {
      this.addDialog = true
    },
    // 添加 KA 卖场
    submitAdd() {
      this.$refs.addForms.validate(async valid => {
        if (valid) {
          this.addForm.areaName = this.filterArea(this.addForm.area)
          await apiKastoreAddKA(this.addForm)
          this.queryData()
          this.closeDialog()
        } else {
          return false
        }
      })
    },
    delKa() {
      const data = this.$refs.gridOptions.getCheckboxRecords()
      if (data?.length) {
        const ids = data.map(v => v.id).join(',')

        this.$confirm('是否确认删除选中的KA卖场?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const res = await apiKastoreDelete({ ids })
          if (res?.status === 1) {
            this.$message.success('删除成功!')
            this.queryData()
          }
        })
      }
    },
    editRow({ row }) {
      this.addDialog = true
      this.$nextTick(() => {
        Object.assign(this.addForm, row)
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 查省市
    async getCityArea(parentId = '0') {
      const params = {
        page: 1,
        pagesize: 1000,
        parentId
      }
      const res = await apiCityArea(params)
      if (parentId === '0') {
        this.provinceList = res.data.Rows
        return
      }
      return res.data.Rows
    },
    // 处理分页事件
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      if (this.queryData) {
        this.queryData()
      }
    },
    reset() {
      this.conditions = {
        shortName: '',
        area: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.addForm {
  .el-form-item {
    .el-form-item__content {
      display: inline-block !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/KAStores.vue